import { produce } from 'immer';
import { SIGN_OUT } from 'store/auth/actions';
import * as actions from 'store/search/actions';
import { SearchState } from 'store/search/types';
import { ActionType, getType, Reducer } from 'typesafe-actions';

const initialState: SearchState = {
  loadKey: '',
  results: {
    asset_ids: [],
    assets: {},
    organisations: {},
    total: null,
  },
};

export const search: Reducer<
  SearchState,
  ActionType<typeof actions | typeof SIGN_OUT.success>
> = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case getType(actions.doCloudPropertiesSetData):
        draft.results = action.payload;
        break;

      case getType(actions.doCloudPropertiesSetLoadKey):
        draft.loadKey = action.payload;
        break;

      case getType(actions.doCloudPropertiesClosed):
      case getType(SIGN_OUT.success):
        return initialState;

      default:
        return state;
    }
  });
